// // import React from 'react';

// // const About = () => {
// //   return (
// //     <div className="pt-24">
// //       {/* Hero Section */}
// //       <section
// //         className="relative h-[60vh] flex items-center justify-center bg-fixed"
// //         style={{
// //           backgroundImage: `linear-gradient(135deg, rgba(30, 27, 26, 0.8), rgba(88, 79, 66, 0.7)), url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920&q=80')`,
// //           backgroundSize: 'cover',
// //           backgroundPosition: 'center',
// //         }}
// //       >
// //         <div className="text-center">
// //           <h1 className="font-serif text-5xl lg:text-7xl font-bold text-luxury-white mb-4">
// //             About Us
// //           </h1>
// //           <p className="text-xl text-luxury-white/90">
// //             Building Excellence Since 2014
// //           </p>
// //         </div>
// //       </section>

// //       {/* Company Story */}
// //       <section className="py-20 lg:py-32 bg-luxury-white">
// //         <div className="container mx-auto px-4 lg:px-8">
// //           <div className="max-w-4xl mx-auto">
// //             <span className="inline-block text-sm font-semibold uppercase tracking-[0.15em] text-luxury-accent mb-4">
// //               Our Story
// //             </span>
// //             <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-8">
// //               Crafting Spaces, Building Futures
// //             </h2>
// //             <p className="text-lg text-luxury-primary leading-relaxed mb-6">
// //               In the last many years, we have completed the 19.02 lakhs sqft land construction. In addition to ownership residential flat constructions, the NIHIRA REALTORS LLP has successfully completed industrial, commercial, special structure projects as well.
// //             </p>
// //             <p className="text-lg text-luxury-primary leading-relaxed mb-6">
// //               At NIHIRA REALTORS LLP, we understand that people everywhere are searching for a home to call their own. We want to make this search as joyful as finally finding the perfect home because we understand that finding a home is much more than an online search!
// //             </p>
// //             <p className="text-lg text-luxury-primary leading-relaxed">
// //               Our commitment to excellence, attention to detail, and customer-centric approach has made us a trusted name in real estate development. Every project we undertake is a testament to our dedication to quality and innovation.
// //             </p>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Values */}
// //       <section className="py-20 lg:py-32 bg-luxury-bg">
// //         <div className="container mx-auto px-4 lg:px-8">
// //           <div className="text-center mb-16">
// //             <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark">
// //               Our Core Values
// //             </h2>
// //           </div>

// //           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
// //             {[
// //               { title: 'Integrity', desc: 'Building trust through honest and transparent practices' },
// //               { title: 'Excellence', desc: 'Delivering quality that exceeds expectations' },
// //               { title: 'Innovation', desc: 'Embracing modern design and construction techniques' },
// //               { title: 'Customer Focus', desc: 'Putting client satisfaction at the heart of everything' },
// //             ].map((value, index) => (
// //               <div
// //                 key={index}
// //                 className="bg-luxury-white p-8 rounded text-center hover:-translate-y-2 transition-all duration-300 hover:shadow-xl"
// //               >
// //                 <div className="w-16 h-1 bg-luxury-accent mx-auto mb-6" />
// //                 <h3 className="font-serif text-2xl font-semibold text-luxury-dark mb-4">
// //                   {value.title}
// //                 </h3>
// //                 <p className="text-luxury-primary leading-relaxed">
// //                   {value.desc}
// //                 </p>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* Stats */}
// //       <section className="py-20 bg-luxury-dark text-luxury-white">
// //         <div className="container mx-auto px-4 lg:px-8">
// //           <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
// //             {[
// //               { number: '19.02L', label: 'Sqft Constructed' },
// //               { number: '10+', label: 'Years Experience' },
// //               { number: '125+', label: 'Villas Delivered' },
// //               { number: '100%', label: 'Client Satisfaction' },
// //             ].map((stat, index) => (
// //               <div key={index} className="text-center">
// //                 <div className="font-serif text-4xl lg:text-6xl font-bold text-luxury-accent mb-2">
// //                   {stat.number}
// //                 </div>
// //                 <div className="text-luxury-secondary uppercase tracking-wider text-sm">
// //                   {stat.label}
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>
// //     </div>
// //   );
// // };

// // export default About;



// import React from 'react';

// const About = () => {
//   return (
//     <div className="about">
//       {/* Hero Section - Split Screen */}
//       <section className="relative min-h-screen flex items-center">
//         <div className="absolute inset-0 grid grid-cols-1 lg:grid-cols-2">
//           {/* Left Side - Dark with Text */}
//           <div 
//             className="relative bg-luxury-dark flex items-center justify-center p-8 lg:p-16"
//             style={{
//               backgroundImage: `linear-gradient(135deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.7)), url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920&q=80')`,
//               backgroundSize: 'cover',
//               backgroundPosition: 'center',
//             }}
//           >
//             <div className="max-w-xl">
//               <h1 className="font-serif text-6xl lg:text-8xl font-bold text-white mb-8">
//                 About us
//               </h1>
//               <div className="w-20 h-1 bg-luxury-accent mb-8"></div>
//               <p className="text-xl text-white/80 leading-relaxed">
//                 NIHIRA REALTORS LLP specializes in creating high-quality residential and commercial spaces that elevate the way people live, work, and grow.
//               </p>
//             </div>
//           </div>

//           {/* Right Side - Image */}
//           <div 
//             className="relative bg-cover bg-center"
//             style={{
//               backgroundImage: `url('https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920&q=80')`,
//             }}
//           >
//             <div className="absolute inset-0 bg-gradient-to-l from-transparent to-luxury-dark/20"></div>
//           </div>
//         </div>
//       </section>

//       {/* Company Introduction */}
//       <section className="py-20 lg:py-32 bg-white">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
//             <div>
//               <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
//                 About NIHIRA REALTORS LLP
//               </span>
//               <h2 className="font-serif text-4xl lg:text-6xl font-bold text-luxury-dark mb-8 leading-tight">
//                 Find Your Dream House With Us
//               </h2>
//               <div className="space-y-6 text-lg text-luxury-primary leading-relaxed">
//                 <p>
//                   Managing Director Mr. PREETHAM has rich experience in running organizations successfully. His logical thought process, analytical concepts, operational proficiency and time management skill guides the success journey of NIHIRA REALTORS LLP. He believes that excellence comes with expertise and expertise comes with experience.
//                 </p>
//                 <p>
//                   Our Clients are our priority, who are the evidence of our achievements, from the exceptional real estate offerings seeking outstanding investment opportunities or an idyllic home. We encourage all businesses, purchasers and even sellers to be part of us and enjoy the professionalism you deserve from us as a real estate client.
//                 </p>
//                 <p>
//                   An intense and systematic approach towards real estate brings the best lands ready for you. As our operational span reaches across each aspect of Real Estate, from identification and acquisition of best properties, detailed project planning, in-house designing team, sales, project management, to property service and maintenance.
//                 </p>
//               </div>
//             </div>

//             <div className="relative">
//               <div className="aspect-[4/5] rounded-lg overflow-hidden shadow-2xl">
//                 <img 
//                   src="https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800&q=80" 
//                   alt="Luxury Property"
//                   className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
//                 />
//               </div>
//               <div className="absolute -bottom-8 -left-8 w-64 h-64 bg-luxury-accent/10 rounded-lg -z-10"></div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Leadership Team */}
//       <section className="py-20 lg:py-32 bg-luxury-bg">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="text-center mb-16">
//             <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
//               Our Leadership
//             </span>
//             <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark">
//               Meet the Team
//             </h2>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto">
//             {/* Managing Partner */}
//             <div className="bg-white rounded-lg overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300">
//               <div className="aspect-[4/5] bg-gradient-to-br from-luxury-accent/20 to-luxury-primary/20 relative overflow-hidden">
//                 <div className="absolute inset-0 flex items-center justify-center">
//                   <div className="text-center text-luxury-dark">
//                     <div className="w-32 h-32 bg-luxury-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
//                       <svg className="w-16 h-16 text-luxury-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
//                       </svg>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="p-8">
//                 <h3 className="font-serif text-3xl font-bold text-luxury-dark mb-2">
//                   Mr. PREETHAM
//                 </h3>
//                 <p className="text-luxury-accent font-semibold mb-4 uppercase tracking-wider text-sm">
//                   Managing Partner
//                 </p>
//                 <p className="text-luxury-primary mb-4">
//                   B.Tech, MBA (USA), LLB
//                 </p>
//                 <p className="text-luxury-primary leading-relaxed">
//                   Brings extensive expertise in organizational management with exceptional analytical skills and operational proficiency.
//                 </p>
//               </div>
//             </div>

//             {/* Advisor */}
//             <div className="bg-white rounded-lg overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300">
//               <div className="aspect-[4/5] bg-gradient-to-br from-luxury-primary/20 to-luxury-accent/20 relative overflow-hidden">
//                 <div className="absolute inset-0 flex items-center justify-center">
//                   <div className="text-center text-luxury-dark">
//                     <div className="w-32 h-32 bg-luxury-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
//                       <svg className="w-16 h-16 text-luxury-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
//                       </svg>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="p-8">
//                 <h3 className="font-serif text-3xl font-bold text-luxury-dark mb-2">
//                   M. Ch. Raghava Rao
//                 </h3>
//                 <p className="text-luxury-accent font-semibold mb-4 uppercase tracking-wider text-sm">
//                   Telangana Builders Federation - Advisor
//                 </p>
//                 <p className="text-luxury-primary mb-4">
//                   Greater West City Builders Association
//                 </p>
//                 <p className="text-luxury-primary leading-relaxed text-sm">
//                   Since 1996, founded multiple construction companies including MARUTHI BUILDERS, VIJAYARAGHAVA CONSTRUCTIONS, and SRI GAJALAKSHMI BUILDERS. Completed 19.02 lakhs sqft construction including the prestigious 650 independent houses project for BHEL employees.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Mission & Vision - Split Layout */}
//       <section className="py-20 lg:py-32 bg-white">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 max-w-6xl mx-auto shadow-2xl rounded-2xl overflow-hidden">
//             {/* Mission */}
//             <div className="bg-gradient-to-br from-luxury-dark to-luxury-primary text-white p-12 lg:p-16">
//               <div className="mb-8">
//                 <svg className="w-16 h-16 text-luxury-accent mb-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//                 </svg>
//               </div>
//               <h3 className="font-serif text-4xl font-bold mb-6">Our Mission</h3>
//               <p className="text-white/90 text-lg leading-relaxed">
//                 At NIHIRA REALTORS LLP, we understand that people everywhere are searching for a home to call their own. We want to make this search as joyful as finally finding the perfect home because we understand that finding a home is much more than an online search!
//               </p>
//             </div>

//             {/* Vision */}
//             <div className="bg-luxury-bg p-12 lg:p-16">
//               <div className="mb-8">
//                 <svg className="w-16 h-16 text-luxury-accent mb-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                 </svg>
//               </div>
//               <h3 className="font-serif text-4xl font-bold text-luxury-dark mb-6">Our Vision</h3>
//               <p className="text-luxury-primary text-lg leading-relaxed">
//                 To contribute growth and progress in the field of Real Estate industry, by creating a newer, better & meaningful world!
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Core Values */}
//       <section className="py-20 lg:py-32 bg-luxury-bg">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="text-center mb-16">
//             <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
//               What We Stand For
//             </span>
//             <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6">
//               Our Core Values
//             </h2>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
//             {[
//               { 
//                 title: 'Transparency in Dealings',
//                 icon: (
//                   <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//                   </svg>
//                 )
//               },
//               { 
//                 title: 'Respecting Every Individual',
//                 icon: (
//                   <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
//                   </svg>
//                 )
//               },
//               { 
//                 title: 'Commitment Towards Work',
//                 icon: (
//                   <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
//                   </svg>
//                 )
//               },
//               { 
//                 title: 'Quick Response to Customer Complaints',
//                 icon: (
//                   <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
//                   </svg>
//                 )
//               },
//               { 
//                 title: 'Flexibility in Addressing Customer Needs',
//                 icon: (
//                   <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
//                   </svg>
//                 )
//               },
//               { 
//                 title: 'We Value Customer Feedback',
//                 icon: (
//                   <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
//                   </svg>
//                 )
//               },
//             ].map((value, index) => (
//               <div
//                 key={index}
//                 className="bg-white p-8 rounded-lg hover:-translate-y-2 transition-all duration-300 shadow-lg hover:shadow-2xl group"
//               >
//                 <div className="w-16 h-16 bg-luxury-accent/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-luxury-accent group-hover:scale-110 transition-all duration-300">
//                   <div className="text-luxury-accent group-hover:text-white transition-colors duration-300">
//                     {value.icon}
//                   </div>
//                 </div>
//                 <h3 className="font-serif text-xl font-semibold text-luxury-dark leading-tight">
//                   {value.title}
//                 </h3>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Key Features - Fast Execution & Quality */}
//       <section className="py-20 bg-white">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-6xl mx-auto">
//             <div className="bg-gradient-to-br from-luxury-accent/10 to-luxury-accent/5 p-12 rounded-lg">
//               <div className="w-20 h-20 bg-luxury-accent rounded-full flex items-center justify-center mb-6">
//                 <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
//                 </svg>
//               </div>
//               <h3 className="font-serif text-3xl font-bold text-luxury-dark mb-4">Fast Executions</h3>
//               <p className="text-luxury-primary leading-relaxed">
//                 We recognize we are a partner with our customers to provide high quality Design and services at a fair price. We focus on supplying our customers excellence in those services and Construct with the highest desire to gain total customer satisfaction, confidence & enthusiasm.
//               </p>
//             </div>

//             <div className="bg-gradient-to-br from-luxury-primary/10 to-luxury-primary/5 p-12 rounded-lg">
//               <div className="w-20 h-20 bg-luxury-primary rounded-full flex items-center justify-center mb-6">
//                 <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
//                 </svg>
//               </div>
//               <h3 className="font-serif text-3xl font-bold text-luxury-dark mb-4">100% Quality</h3>
//               <p className="text-luxury-primary leading-relaxed">
//                 The quality policy of NIHIRA REALTORS LLP remains committed to Current Good Construction Practices and conforms to Best Standards.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Process Steps */}
//       <section className="py-20 lg:py-32 bg-gradient-to-b from-luxury-bg to-white">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="text-center mb-16">
//             <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
//               Explore Process
//             </span>
//             <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6">
//               Step By Step We Implement<br />Your Project
//             </h2>
//           </div>

//           <div className="max-w-5xl mx-auto">
//             {[
//               { 
//                 step: '1', 
//                 title: 'Book Now', 
//                 desc: 'Call & Book a Visit',
//                 phone: '+91 9989336464',
//                 detail: 'Listing the requirement'
//               },
//               { 
//                 step: '2', 
//                 title: 'Organizing the Viewing', 
//                 desc: 'Discuss your Needs',
//                 detail: 'Customize or create your own best suited Home Solution'
//               },
//               { 
//                 step: '3', 
//                 title: 'Accept Quote', 
//                 desc: 'Negotiation',
//                 detail: 'Review and finalize the terms'
//               },
//               { 
//                 step: '4', 
//                 title: 'Closing the Deal', 
//                 desc: 'Finalize Agreement',
//                 detail: 'Complete documentation and payment process'
//               },
//               { 
//                 step: '5', 
//                 title: 'Project Handover', 
//                 desc: 'Move into Your Dream Home',
//                 detail: 'Final inspection and key delivery'
//               },
//             ].map((item, index) => (
//               <div key={index} className="relative">
//                 <div className="flex gap-8 items-start mb-12 group">
//                   {/* Step Number */}
//                   <div className="flex-shrink-0">
//                     <div className="w-20 h-20 rounded-full bg-gradient-to-br from-luxury-accent to-luxury-primary text-white flex items-center justify-center font-serif text-2xl font-bold shadow-lg group-hover:scale-110 transition-transform duration-300">
//                       {item.step}
//                     </div>
//                   </div>

//                   {/* Content */}
//                   <div className="flex-grow bg-white p-8 rounded-lg shadow-md group-hover:shadow-xl transition-all duration-300 group-hover:-translate-y-1">
//                     <h3 className="font-serif text-2xl font-bold text-luxury-dark mb-2">
//                       {item.title}
//                     </h3>
//                     <p className="text-luxury-accent font-semibold mb-3 uppercase text-sm tracking-wider">
//                       {item.desc}
//                     </p>
//                     <p className="text-luxury-primary leading-relaxed">
//                       {item.detail}
//                     </p>
//                     {item.phone && (
//                       <a 
//                         href={`tel:${item.phone}`}
//                         className="inline-flex items-center gap-2 mt-4 text-luxury-accent hover:text-luxury-primary font-semibold transition-colors"
//                       >
//                         <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
//                         </svg>
//                         {item.phone}
//                       </a>
//                     )}
//                   </div>
//                 </div>

//                 {/* Connector Line */}
//                 {index < 4 && (
//                   <div className="absolute left-10 top-20 w-0.5 h-12 bg-gradient-to-b from-luxury-accent to-luxury-primary"></div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Stats Section */}
//       <section className="py-20 bg-gradient-to-br from-luxury-dark via-luxury-primary to-luxury-dark text-white relative overflow-hidden">
//         <div className="absolute inset-0 opacity-10">
//           <div className="absolute top-0 left-0 w-96 h-96 bg-luxury-accent rounded-full blur-3xl"></div>
//           <div className="absolute bottom-0 right-0 w-96 h-96 bg-luxury-accent rounded-full blur-3xl"></div>
//         </div>
        
//         <div className="container mx-auto px-4 lg:px-8 relative z-10">
//           <div className="text-center mb-12">
//             <h2 className="font-serif text-4xl lg:text-5xl font-bold mb-4">
//               Our Achievements
//             </h2>
//             <p className="text-white/80 text-lg">
//               Building Trust Through Numbers
//             </p>
//           </div>

//           <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
//             {[
//               { number: '19.02L', label: 'Sqft Constructed', sublabel: 'Total Area Developed' },
//               { number: '650+', label: 'Independent Houses', sublabel: 'BHEL Project' },
//               { number: '25+', label: 'Years Experience', sublabel: 'Combined Expertise' },
//               { number: '100%', label: 'Client Satisfaction', sublabel: 'Quality Guaranteed' },
//             ].map((stat, index) => (
//               <div key={index} className="text-center group">
//                 <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 hover:bg-white/20 transition-all duration-300 hover:-translate-y-2">
//                   <div className="font-serif text-5xl lg:text-6xl font-bold text-luxury-accent mb-2 group-hover:scale-110 transition-transform duration-300">
//                     {stat.number}
//                   </div>
//                   <div className="text-white font-semibold uppercase tracking-wider text-sm mb-1">
//                     {stat.label}
//                   </div>
//                   <div className="text-white/70 text-xs">
//                     {stat.sublabel}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Success Attributes */}
//       <section className="py-20 bg-luxury-white">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="max-w-4xl mx-auto">
//             <h2 className="font-serif text-3xl lg:text-4xl font-bold text-luxury-dark mb-12 text-center">
//               Our Continuous Success Attributes To:
//             </h2>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               {[
//                 'Strong engineering team and contractors',
//                 'Honest and transparent interaction with customers',
//                 'Understanding the customer\'s need & adapt to it',
//                 'Prompt feedback and action to customer\'s requirements',
//                 'Acting as a "Trustee" to the customer\'s money during the project period',
//               ].map((item, index) => (
//                 <div key={index} className="flex items-start gap-4 bg-luxury-bg p-6 rounded-lg hover:shadow-lg transition-shadow duration-300">
//                   <div className="flex-shrink-0 w-6 h-6 bg-luxury-accent rounded-full flex items-center justify-center mt-1">
//                     <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
//                     </svg>
//                   </div>
//                   <p className="text-luxury-primary leading-relaxed">{item}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="py-20 bg-gradient-to-r from-luxury-accent to-luxury-primary text-white">
//         <div className="container mx-auto px-4 text-center">
//           <h2 className="font-serif text-4xl lg:text-5xl font-bold mb-6">
//             Ready to Start Your Journey?
//           </h2>
//           <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
//             Let's discuss your dream property and turn it into reality
//           </p>
//           <div className="flex flex-col sm:flex-row gap-6 justify-center">
//             <a
//               href="/contact"
//               className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-white text-luxury-accent font-semibold uppercase tracking-wider rounded-lg hover:bg-luxury-bg transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
//             >
//               Contact Us Today
//               <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
//               </svg>
//             </a>
//             <a
//               href="tel:+919584646464"
//               className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-transparent border-2 border-white text-white font-semibold uppercase tracking-wider rounded-lg hover:bg-white hover:text-luxury-accent transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
//             >
//               <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
//               </svg>
//               Call Now
//             </a>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default About;


import React, { useRef, useState, useEffect } from 'react';
import clubhouse2 from '../Assets/CLUB HOUSE ELVATION -  (2).jpg';

const RevealImage = ({ src, alt, className = "" }) => {
  const wrapperRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = wrapperRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsRevealed(true);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.3 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);
  
  return (
    <div ref={wrapperRef} className={`relative overflow-hidden ${className}`}>
      <img 
        src={src} 
        alt={alt} 
        className={`w-full h-full object-cover relative z-[1] transition-all duration-[1500ms] ease-out ${
          isRevealed ? 'opacity-100 scale-100 blur-0' : 'opacity-0 scale-110 blur-sm'
        }`}
        style={{ transitionDelay: '800ms' }}
      />
      
      {/* PURE SILVER Gradient Mask */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[2] transition-transform duration-[1500ms] ${
          isRevealed ? 'scale-x-0 origin-right' : 'scale-x-100 origin-left'
        }`}
        style={{ 
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
          background: 'linear-gradient(90deg, #C0C0C0 0%, #E8E8E8 25%, #FFFFFF 50%, #E8E8E8 75%, #C0C0C0 100%)'
        }}
      />
      
      {/* Silver Shimmer */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[3] transition-all duration-[1500ms] ${
          isRevealed ? 'opacity-0 translate-x-full' : 'opacity-100 translate-x-0'
        }`}
        style={{ 
          transitionDelay: '300ms',
          background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.8) 50%, transparent 100%)',
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)'
        }}
      />
    </div>
  );
};

const RevealContent = ({ children, className = "", delay = 0 }) => {
  const contentRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = contentRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              setIsRevealed(true);
            }, delay);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, [delay]);
  
  return (
    <div 
      ref={contentRef} 
      className={`transition-all duration-1000 ${
        isRevealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[60px]'
      } ${className}`}
      style={{ transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
    >
      {children}
    </div>
  );
};

const About = () => {
  return (
    <div className="about">
      {/* Hero Section - Split Screen */}
      <section className="relative min-h-screen flex items-center">
        <div className="absolute inset-0 grid grid-cols-1 lg:grid-cols-2">
          {/* Left Side - Dark with Text */}
          <div 
            className="relative bg-luxury-dark flex items-center justify-center p-8 lg:p-16 min-h-[50vh] lg:min-h-screen"
            style={{
              backgroundImage: `linear-gradient(135deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.7)), url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920&q=80')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <RevealContent className="w-full">
              <h1 className="font-serif text-5xl lg:text-8xl font-bold text-white mb-8">
                About us
              </h1>
              <div className="w-20 h-1 bg-luxury-accent mb-8"></div>
              <p className="text-xl text-white/80 leading-relaxed">
                NIHIRA REALTORS LLP specializes in creating high-quality residential and commercial spaces that elevate the way people live, work, and grow.
              </p>
            </RevealContent>
          </div>

          {/* Right Side - Image */}
          <div 
            className="relative bg-cover bg-center min-h-[50vh] lg:min-h-screen"
            style={{
              backgroundImage: `url('https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920&q=80')`,
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-l from-transparent to-luxury-dark/20"></div>
          </div>
        </div>
      </section>

      {/* Company Introduction */}
      <section className="py-20 lg:py-32 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <RevealContent delay={100}>
                <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
                  About NIHIRA REALTORS LLP
                </span>
                <h2 className="font-serif text-4xl lg:text-6xl font-bold text-luxury-dark mb-8 leading-tight">
                  Find Your Dream House With Us
                </h2>
                <div className="space-y-6 text-lg text-luxury-primary leading-relaxed">
                  <p>
                    Managing Director Mr. PREETHAM has rich experience in running organizations successfully. His logical thought process, analytical concepts, operational proficiency and time management skill guides the success journey of NIHIRA REALTORS LLP. He believes that excellence comes with expertise and expertise comes with experience.
                  </p>
                  <p>
                    Our Customers are our priority, who are the evidence of our achievements, from the exceptional real estate offerings seeking outstanding investment opportunities or an idyllic home. We encourage all businesses, purchasers and even sellers to be part of us and enjoy the professionalism you deserve from us as a real estate client.
                  </p>
                  <p>
                    An intense and systematic approach towards real estate brings the best lands ready for you. As our operational span reaches across each aspect of Real Estate, from identification and acquisition of best properties, detailed project planning, in-house designing team, sales, project management, to property service and maintenance.
                  </p>
                </div>
              </RevealContent>

              <RevealContent delay={300} className="relative">
                <RevealImage 
                  src={clubhouse2}
                  alt="Luxury Property"
                  className="aspect-[4/5] rounded-lg shadow-2xl"
                />
                <div className="absolute -bottom-8 -left-8 w-64 h-64 bg-luxury-accent/10 rounded-lg -z-10"></div>
              </RevealContent>
            </div>
          </div>
        </div>
      </section>

      {/* Leadership Team */}
      <section className="py-20 lg:py-32 bg-luxury-bg">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <RevealContent className="text-center mb-16">
              <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
                Our Leadership
              </span>
              <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark">
                Meet the Team
              </h2>
            </RevealContent>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              {/* Managing Partner */}
              <RevealContent delay={100}>
                <div className="bg-white rounded-lg overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300 h-full flex flex-col">
                  <div className="aspect-[4/5] bg-gradient-to-br from-luxury-accent/20 to-luxury-primary/20 relative overflow-hidden flex-shrink-0">
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="text-center text-luxury-dark">
                        <div className="w-32 h-32 bg-luxury-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
                          <svg className="w-16 h-16 text-luxury-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-8 flex-grow flex flex-col">
                    <h3 className="font-serif text-3xl font-bold text-luxury-dark mb-2">
                      Mr. PREETHAM
                    </h3>
                    <p className="text-luxury-accent font-semibold mb-4 uppercase tracking-wider text-sm">
                      Managing Partner
                    </p>
                    <p className="text-luxury-primary mb-4">
                      B.Tech, MBA (USA), LLB
                    </p>
                    <p className="text-luxury-primary leading-relaxed">
                      Brings extensive expertise in organizational management with exceptional analytical skills and operational proficiency.
                    </p>
                  </div>
                </div>
              </RevealContent>

              {/* Advisor */}
              <RevealContent delay={200}>
                <div className="bg-white rounded-lg overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300 h-full flex flex-col">
                  <div className="aspect-[4/5] bg-gradient-to-br from-luxury-primary/20 to-luxury-accent/20 relative overflow-hidden flex-shrink-0">
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="text-center text-luxury-dark">
                        <div className="w-32 h-32 bg-luxury-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                          <svg className="w-16 h-16 text-luxury-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-8 flex-grow flex flex-col">
                    <h3 className="font-serif text-3xl font-bold text-luxury-dark mb-2">
                      M. Ch. Raghava Rao
                    </h3>
                    <p className="text-luxury-accent font-semibold mb-4 uppercase tracking-wider text-sm">
                      Telangana Builders Federation - Advisor
                    </p>
                    <p className="text-luxury-primary mb-4">
                      Greater West City Builders Association
                    </p>
                    <p className="text-luxury-primary leading-relaxed text-sm">
                      Since 1996, founded multiple construction companies including MARUTHI BUILDERS, VIJAYARAGHAVA CONSTRUCTIONS, and SRI GAJALAKSHMI BUILDERS. Completed 19.02 lakhs sqft construction including the prestigious 650 independent houses project for BHEL employees.
                    </p>
                  </div>
                </div>
              </RevealContent>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision - Split Layout */}
      <section className="py-20 lg:py-32 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 shadow-2xl rounded-2xl overflow-hidden">
              {/* Mission */}
              <RevealContent delay={100} className="h-full">
                <div className="bg-gradient-to-br from-luxury-dark to-luxury-primary text-white p-12 lg:p-16 h-full flex flex-col justify-center">
                  <div className="mb-8">
                    <svg className="w-16 h-16 text-luxury-accent mb-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h3 className="font-serif text-4xl font-bold mb-6">Our Mission</h3>
                  <p className="text-white/90 text-lg leading-relaxed">
                    At NIHIRA REALTORS LLP, we understand that people everywhere are searching for a home to call their own. We want to make this search as joyful as finally finding the perfect home because we understand that finding a home is much more than an online search!
                  </p>
                </div>
              </RevealContent>

              {/* Vision */}
              <RevealContent delay={200} className="h-full">
                <div className="bg-luxury-bg p-12 lg:p-16 h-full flex flex-col justify-center">
                  <div className="mb-8">
                    <svg className="w-16 h-16 text-luxury-accent mb-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                  </div>
                  <h3 className="font-serif text-4xl font-bold text-luxury-dark mb-6">Our Vision</h3>
                  <p className="text-luxury-primary text-lg leading-relaxed">
                    To contribute growth and progress in the field of Real Estate industry, by creating a newer, better & meaningful world!
                  </p>
                </div>
              </RevealContent>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-20 lg:py-32 bg-luxury-bg">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <RevealContent className="text-center mb-16">
              <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
                What We Stand For
              </span>
              <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6">
                Our Core Values
              </h2>
            </RevealContent>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                { 
                  title: 'Transparency in Dealings',
                  icon: (
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  )
                },
                { 
                  title: 'Respecting Every Individual',
                  icon: (
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                    </svg>
                  )
                },
                { 
                  title: 'Commitment Towards Work',
                  icon: (
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                    </svg>
                  )
                },
                { 
                  title: 'Quick Response to Customer Complaints',
                  icon: (
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  )
                },
                { 
                  title: 'Flexibility in Addressing Customer Needs',
                  icon: (
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                  )
                },
                { 
                  title: 'We Value Customer Feedback',
                  icon: (
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                    </svg>
                  )
                },
              ].map((value, index) => (
                <RevealContent 
                  key={index}
                  delay={100 * (index + 1)}
                  className="h-full"
                >
                  <div className="bg-white p-8 rounded-lg hover:-translate-y-2 transition-all duration-300 shadow-lg hover:shadow-2xl group h-full flex flex-col">
                    <div className="w-16 h-16 bg-luxury-accent/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-luxury-accent group-hover:scale-110 transition-all duration-300 flex-shrink-0">
                      <div className="text-luxury-accent group-hover:text-white transition-colors duration-300">
                        {value.icon}
                      </div>
                    </div>
                    <h3 className="font-serif text-xl font-semibold text-luxury-dark leading-tight">
                      {value.title}
                    </h3>
                  </div>
                </RevealContent>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Key Features - Fast Execution & Quality */}
      <section className="py-20 lg:py-32 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              <RevealContent delay={100} className="h-full">
                <div className="bg-gradient-to-br from-luxury-accent/10 to-luxury-accent/5 p-12 rounded-lg h-full flex flex-col">
                  <div className="w-20 h-20 bg-luxury-accent rounded-full flex items-center justify-center mb-6 flex-shrink-0">
                    <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                  <h3 className="font-serif text-3xl font-bold text-luxury-dark mb-4">Fast Executions</h3>
                  <p className="text-luxury-primary leading-relaxed flex-grow">
                    We recognize we are a partner with our customers to provide high quality Design and services at a fair price. We focus on supplying our customers excellence in those services and Construct with the highest desire to gain total customer satisfaction, confidence & enthusiasm.
                  </p>
                </div>
              </RevealContent>

              <RevealContent delay={200} className="h-full">
                <div className="bg-gradient-to-br from-luxury-primary/10 to-luxury-primary/5 p-12 rounded-lg h-full flex flex-col">
                  <div className="w-20 h-20 bg-luxury-primary rounded-full flex items-center justify-center mb-6 flex-shrink-0">
                    <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                    </svg>
                  </div>
                  <h3 className="font-serif text-3xl font-bold text-luxury-dark mb-4">100% Quality</h3>
                  <p className="text-luxury-primary leading-relaxed flex-grow">
                    The quality policy of NIHIRA REALTORS LLP remains committed to Current Good Construction Practices and conforms to Best Standards.
                  </p>
                </div>
              </RevealContent>
            </div>
          </div>
        </div>
      </section>

      {/* Process Steps */}
      <section className="py-20 lg:py-32 bg-gradient-to-b from-luxury-bg to-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <RevealContent className="text-center mb-16">
              <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
                Explore Process
              </span>
              <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6">
                Step By Step We Implement<br />Your Project
              </h2>
            </RevealContent>

            <div>
              {[
                { 
                  step: '1', 
                  title: 'Book Now', 
                  desc: 'Call & Book a Visit',
                  phone: '+91 9989336464',
                  detail: 'Listing the requirement'
                },
                { 
                  step: '2', 
                  title: 'Organizing the Viewing', 
                  desc: 'Discuss your Needs',
                  detail: 'Customize or create your own best suited Home Solution'
                },
                { 
                  step: '3', 
                  title: 'Accept Quote', 
                  desc: 'Negotiation',
                  detail: 'Review and finalize the terms'
                },
                { 
                  step: '4', 
                  title: 'Closing the Deal', 
                  desc: 'Finalize Agreement',
                  detail: 'Complete documentation and payment process'
                },
                { 
                  step: '5', 
                  title: 'Project Handover', 
                  desc: 'Move into Your Dream Home',
                  detail: 'Final inspection and key delivery'
                },
              ].map((item, index) => (
                <RevealContent key={index} delay={100 * (index + 1)}>
                  <div className="relative">
                    <div className="flex gap-8 items-start mb-12 group">
                      {/* Step Number */}
                      <div className="flex-shrink-0">
                        <div className="w-20 h-20 rounded-full bg-gradient-to-br from-luxury-accent to-luxury-primary text-white flex items-center justify-center font-serif text-2xl font-bold shadow-lg group-hover:scale-110 transition-transform duration-300">
                          {item.step}
                        </div>
                      </div>

                      {/* Content */}
                      <div className="flex-grow bg-white p-8 rounded-lg shadow-md group-hover:shadow-xl transition-all duration-300 group-hover:-translate-y-1">
                        <h3 className="font-serif text-2xl font-bold text-luxury-dark mb-2">
                          {item.title}
                        </h3>
                        <p className="text-luxury-accent font-semibold mb-3 uppercase text-sm tracking-wider">
                          {item.desc}
                        </p>
                        <p className="text-luxury-primary leading-relaxed">
                          {item.detail}
                        </p>
                        {item.phone && (
                          <a 
                            href={`tel:${item.phone}`}
                            className="inline-flex items-center gap-2 mt-4 text-luxury-accent hover:text-luxury-primary font-semibold transition-colors"
                          >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                            </svg>
                            {item.phone}
                          </a>
                        )}
                      </div>
                    </div>

                    {/* Connector Line */}
                    {index < 4 && (
                      <div className="absolute left-10 top-20 w-0.5 h-12 bg-gradient-to-b from-luxury-accent to-luxury-primary"></div>
                    )}
                  </div>
                </RevealContent>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 lg:py-32 bg-gradient-to-br from-luxury-dark via-luxury-primary to-luxury-dark text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-luxury-accent rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-luxury-accent rounded-full blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-4 lg:px-8 relative z-10">
          <div className="max-w-7xl mx-auto">
            <RevealContent className="text-center mb-12">
              <h2 className="font-serif text-4xl lg:text-5xl font-bold mb-4">
                Our Achievements
              </h2>
              <p className="text-white/80 text-lg">
                Building Trust Through Numbers
              </p>
            </RevealContent>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                { number: '19.02L', label: 'Sqft Constructed', sublabel: 'Total Area Developed' },
                { number: '650+', label: 'Independent Houses', sublabel: 'BHEL Project' },
                { number: '25+', label: 'Years Experience', sublabel: 'Combined Expertise' },
                { number: '100%', label: 'Customer Satisfaction', sublabel: 'Quality Guaranteed' },
              ].map((stat, index) => (
                <RevealContent key={index} delay={100 * (index + 1)}>
                  <div className="text-center group h-full">
                    <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 hover:bg-white/20 transition-all duration-300 hover:-translate-y-2 h-full flex flex-col justify-center">
                      <div className="font-serif text-5xl lg:text-6xl font-bold text-luxury-accent mb-2 group-hover:scale-110 transition-transform duration-300">
                        {stat.number}
                      </div>
                      <div className="text-white font-semibold uppercase tracking-wider text-sm mb-1">
                        {stat.label}
                      </div>
                      <div className="text-white/70 text-xs">
                        {stat.sublabel}
                      </div>
                    </div>
                  </div>
                </RevealContent>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Success Attributes */}
      <section className="py-20 lg:py-32 bg-luxury-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <RevealContent>
              <h2 className="font-serif text-3xl lg:text-4xl font-bold text-luxury-dark mb-12 text-center">
                Our Continuous Success Attributes To:
              </h2>
            </RevealContent>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                'Strong engineering team and contractors',
                'Honest and transparent interaction with customers',
                'Understanding the customer\'s need & adapt to it',
                'Prompt feedback and action to customer\'s requirements',
                'Acting as a "Trustee" to the customer\'s money during the project period',
              ].map((item, index) => (
                <RevealContent key={index} delay={100 * (index + 1)} className="h-full">
                  <div className="flex items-start gap-4 bg-luxury-bg p-6 rounded-lg hover:shadow-lg transition-shadow duration-300 h-full">
                    <div className="flex-shrink-0 w-6 h-6 bg-luxury-accent rounded-full flex items-center justify-center mt-1">
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p className="text-luxury-primary leading-relaxed">{item}</p>
                  </div>
                </RevealContent>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 lg:py-32 bg-gradient-to-r from-luxury-accent to-luxury-primary text-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto text-center">
            <RevealContent>
              <h2 className="font-serif text-4xl lg:text-5xl font-bold mb-6">
                Ready to Start Your Journey?
              </h2>
              <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
                Let's discuss your dream property and turn it into reality
              </p>
              <div className="flex flex-col sm:flex-row gap-6 justify-center">
                <a
                  href="/contact"
                  className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-white text-luxury-accent font-semibold uppercase tracking-wider rounded-lg hover:bg-luxury-bg transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
                >
                  Contact Us Today
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </a>
                <a
                  href="tel:+919584646464"
                  className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-transparent border-2 border-white text-white font-semibold uppercase tracking-wider rounded-lg hover:bg-white hover:text-luxury-accent transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  Call Now
                </a>
              </div>
            </RevealContent>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;